import { MaterialReactTable } from "material-react-table";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { table4d5dColumns } from "./columns";
import { scheduleData } from "./dummyData";
import { Box, Button, MenuItem, Stack, Typography } from "@mui/material";
import TimelineComponent from "./TimelineComponent";
import { useParams } from "react-router-dom";
import ScheduleComponent from "./ScheduleComponent";
import SubTaskModal from "./SubTasksModal";
// import { getEquip4d5d } from '../../PMSTab/4d5d/api'
// import Project4d5d from '../../PMSTab/4d5d'
import {
  getSchedule,
  getTrackItem,
  updateSchedule,
  update4D,
  getProjectData,
  getPlantData,
} from "./api";
import { tableWithBorderedCells } from "../../../../../../styles/muiProps";
import TrackItemDialog from "./TrackItemDialog";
// import { AdjustedData } from "./dummyData";
// import RowEditableTable from "../../../../../../components/Tables/RowEditableTable";
import { AuthContext } from "../../../../../../context/authContext";
// import Gantt from 'frappe-gantt'

const Project4d = ({ plant = false, projectFilter = [] }) => {
  const { id: projectIdFromRoute, plantId } = useParams();
  const { accessToken } = useContext(AuthContext);
  const [rows, setRows] = useState([]);
  const [allTasks, setAllTasks] = useState([]);
  const [trackItemDialog, setTrackItemDialog] = useState(dialogInitalState);
  const [stats, setStats] = useState({
    totalEstimatedTime: 0,
    averageProgress: 0,
  });

  const { totalEstimatedTime, averageProgress } = stats;

  const onSave = async () => {
    updateSchedule({ scheduleTasks: rows });
  };

  const onTrackItem = async (row) => {
    console.log(row);
    const result = await getTrackItem(row.original.id).then((res) =>
      setTrackItemDialog((prev) => ({
        ...prev,
        open: true,
        item: row.original,
        data: res,
      }))
    );
  };

  const onClose = async () => {
    setTrackItemDialog(dialogInitalState);
  };

  // Format tasks to ensure consistent structure for 4D display
  const formatTasksFor4D = (tasks) => {
    if (!Array.isArray(tasks)) return [];
    
    return tasks.map((taskItem) => {
      // Normalize task structure - handle both project and plant tasks
      return {
        id: taskItem.id,
        taskCode: taskItem.taskCode || '',
        name: taskItem.name || null, // For project tasks
        task: taskItem.task || null, // For plant tasks
        progress: taskItem.progress ?? 0,
        startDate: taskItem.startDate || null,
        endDate: taskItem.endDate || taskItem.targetDate || null,
        revisedStart: taskItem.revisedStart || taskItem.revisedStartDate || null,
        revisedEnd: taskItem.revisedEnd || taskItem.revisedEndDate || null,
        actualStart: taskItem.actualStart || null,
        actualEnd: taskItem.actualEnd || null,
      };
    }).filter((task) => task.taskCode); // Only include tasks with taskCode
  };

  const buildRowsFromTasks = (tasks) => {
    if (!Array.isArray(tasks) || tasks.length === 0) {
      setRows([]);
      setAllTasks([]);
      setStats({
        totalEstimatedTime: 0,
        averageProgress: 0,
      });
      return;
    }

    // Calculate stats (total manhours and cumulative progress) from raw tasks
    let totalEst = 0;
    let totalProg = 0;
    let count = 0;

    tasks.forEach((task) => {
      const est = parseFloat(task.estimatedTime);
      if (!isNaN(est)) {
        totalEst += est;
      }

      const prog = parseFloat(task.progress);
      if (!isNaN(prog)) {
        totalProg += prog;
        count += 1;
      }
    });

    setStats({
      totalEstimatedTime: totalEst,
      averageProgress: count ? totalProg / count : 0,
    });

    // Format tasks first to ensure consistent structure
    const formattedTasks = formatTasksFor4D(tasks);
    if (formattedTasks.length === 0) {
      setRows([]);
      setAllTasks([]);
      return;
    }

    setAllTasks(formattedTasks);
    const reducedTasks = formattedTasks.reduce((acc, taskItem) => {
      // Handle both project tasks (with 'name') and plant tasks (with 'task')
      const {
        taskCode,
        name,
        task, // For plant tasks
        progress,
        startDate,
        endDate: targetDate,
        revisedStart,
        revisedEnd,
        actualStart,
        actualEnd,
      } = taskItem;
      
      // Use 'name' for project tasks or 'task' for plant tasks
      const taskName = name || task || '';

      if (!acc[taskCode]) {
        acc[taskCode] = {
          taskCode,
          tasks: [],
          completedTasks: 0,
          totalTasks: 0,
          completionRate: 0,
          startDate,
          targetDate,
          revisedStart: revisedStart || null,
          revisedEnd: revisedEnd || null,
          actualStart: actualStart || null,
          actualEnd: actualEnd || null,
        };
      }

      // Add task details
      acc[taskCode].tasks.push({
        name: taskName,
        progress,
        startDate,
        targetDate,
        revisedStart,
        revisedEnd,
        actualStart,
        actualEnd,
      });

      // Update task counts
      acc[taskCode].totalTasks += 1;
      if (progress >= 100) acc[taskCode].completedTasks += 1;

      // Update startDate to the earliest date
      if (new Date(startDate) < new Date(acc[taskCode].startDate)) {
        acc[taskCode].startDate = startDate;
      }

      // Update targetDate to the latest date
      if (new Date(targetDate) > new Date(acc[taskCode].targetDate)) {
        acc[taskCode].targetDate = targetDate;
      }

      // Update revisedStart to the earliest date
      if (
        revisedStart &&
        (!acc[taskCode].revisedStart ||
          new Date(revisedStart) < new Date(acc[taskCode].revisedStart))
      ) {
        acc[taskCode].revisedStart = revisedStart;
      }

      // Update revisedEnd to the latest date
      if (
        revisedEnd &&
        (!acc[taskCode].revisedEnd ||
          new Date(revisedEnd) > new Date(acc[taskCode].revisedEnd))
      ) {
        acc[taskCode].revisedEnd = revisedEnd;
      }

      // Update actualStart to the earliest date
      if (
        actualStart &&
        (!acc[taskCode].actualStart ||
          new Date(actualStart) < new Date(acc[taskCode].actualStart))
      ) {
        acc[taskCode].actualStart = actualStart;
      }

      // Update actualEnd to the latest date
      if (
        actualEnd &&
        (!acc[taskCode].actualEnd ||
          new Date(actualEnd) > new Date(acc[taskCode].actualEnd))
      ) {
        acc[taskCode].actualEnd = actualEnd;
      }

      // Calculate completion rate
      acc[taskCode].completionRate =
        (acc[taskCode].completedTasks / acc[taskCode].totalTasks) * 100;

      return acc;
    }, {});

    const tableArray = Object.values(reducedTasks).map((taskGroup) => ({
      name: taskGroup.taskCode,
      completedTasks: taskGroup.completedTasks,
      totalTasks: taskGroup.totalTasks,
      progress: taskGroup.completionRate.toFixed(0), // As a percentage
      plannedStart: taskGroup.startDate,
      plannedEnd: taskGroup.targetDate,
      revisedStart: taskGroup.revisedStart || null,
      revisedEnd: taskGroup.revisedEnd || null,
      actualStart: taskGroup.actualStart || null,
      actualEnd: taskGroup.actualEnd || null,
    }));

    const sortedData = tableArray.sort((a, b) => {
      const dateA = a.plannedStart ? new Date(a.plannedStart) : new Date(0);
      const dateB = b.plannedStart ? new Date(b.plannedStart) : new Date(0);
      return dateA - dateB;
    });

    setRows(sortedData);
  };

  useEffect(() => {
    console.log('plantsssssssss two',plant);
    
    const arrange4dData = async () => {
      // if (!accessToken) return;
      console.log('plantsssssssss one',plant);
      
      // Normal project mode - get all tasks for the project
      if (!plant) {
        if (!projectIdFromRoute) {
          setRows([]);
          setAllTasks([]);
          return;
        }
        try {
          const tasks = await getProjectData(projectIdFromRoute, accessToken);
          console.log("4D tasks (single project)", tasks);
          // Ensure tasks is an array
          const tasksArray = Array.isArray(tasks) ? tasks : [];
          buildRowsFromTasks(tasksArray);
        } catch (e) {
          console.error("Error loading 4D data for project:", e);
          setRows([]);
          setAllTasks([]);
        }
        return;
      }

      // Plant mode - get all tasks for the plant
      if (!plantId) {
        setRows([]);
        setAllTasks([]);
        return;
      }
      console.log('asdfsafdds');
      
      try {
        console.log('plantsssssssssId',plantId);
        
        const tasks = await getPlantData(plantId, accessToken);
        console.log("4D tasks (plant)", tasks);
        // Ensure tasks is an array
        const tasksArray = Array.isArray(tasks) ? tasks : [];
        buildRowsFromTasks(tasksArray);
      } catch (e) {
        console.error("Error arranging 4D data for plant:", e);
        setRows([]);
        setAllTasks([]);
      }
    };

    arrange4dData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plant, plantId, projectIdFromRoute, accessToken]);

  const onRowClick = (row) => {
    console.log("row clicked", row);

    // const matchedGroup = rows.find((r) => r.name === row.original.name);
    // const groupTasks = rows
    //   .filter((t) => t.taskCode === row.original.name)
    //   .map((task) => ({
    //     ...task,
    //   }));
    setTrackItemDialog({
      ...trackItemDialog,
      open: true,
      taskGroupName: row.original.name,
    });
  };

  return (
    <Box p={2}>
      <Stack
        sx={{ paddingBottom: "2rem" }}
        direction={"row"}
        justifyContent="space-between"
        height={"3rem"}
        alignItems="center"
      >
        <h2>Schedule</h2>
      </Stack>
      {!plant && (
        <Box
          sx={{
            display: "flex",
            gap: 4,
            mb: 2,
            flexWrap: "wrap",
          }}
        >
          <Typography variant="subtitle1">
            Total Manhour: <strong>{totalEstimatedTime.toFixed(2)}</strong>
          </Typography>
          <Typography variant="subtitle1">
            Cummulative Progress: <strong>{averageProgress.toFixed(1)}%</strong>
          </Typography>
        </Box>
      )}
      <ScheduleComponent
        rows={rows}
        setRows={setRows}
        projectId={projectIdFromRoute}
        onRowClick={onRowClick}
      />
      <SubTaskModal
        taskGroupName={trackItemDialog.taskGroupName}
        open={trackItemDialog.open}
        onClose={onClose}
        tasks={allTasks}
      />
      {/* <TrackItemDialog
        open={trackItemDialog.open}
        onClose={onClose}
        item={trackItemDialog.item}
        data={trackItemDialog.data}
      /> */}
    </Box>
  );
};
export default Project4d;

const dialogInitalState = {
  open: false,
  taskGroupName: null,
};
